import { toast } from 'react-toastify';

// Heads-up toast when a roster change promoted family contacts to keep containment — a Full athlete's contacts
// must be Members (docs/role-and-deletion-design.html §5.6). Reads the `promotedContacts` array the add / edit /
// link athlete endpoints return alongside their success response. No-op when nothing was promoted.
export const notifyContactPromotions = (response) => {
  const promoted = response?.data?.promotedContacts;
  if (!Array.isArray(promoted) || promoted.length === 0) return;
  const names =
    promoted.length === 1
      ? promoted[0]
      : `${promoted.slice(0, -1).join(', ')} and ${promoted[promoted.length - 1]}`;
  toast.info(
    `${names} ${promoted.length === 1 ? 'was' : 'were'} promoted to Member to match their athlete's full membership.`
  );
};

// Heads-up toast when a roster change reclassified family contacts from Visitor to Guest — the contact class tracks
// the family's max athlete type (Member>Guest>Visitor), so converting a Visitor athlete to a Guest lifts its Visitor
// contacts to Guest (a categorical change within the same access tier, distinct from the Member promotion above).
// Reads the `reclassifiedContacts` array the add / edit / link athlete endpoints return. No-op when nothing changed.
export const notifyContactReclassifications = (response) => {
  const reclassified = response?.data?.reclassifiedContacts;
  if (!Array.isArray(reclassified) || reclassified.length === 0) return;
  const names =
    reclassified.length === 1
      ? reclassified[0]
      : `${reclassified.slice(0, -1).join(', ')} and ${reclassified[reclassified.length - 1]}`;
  toast.info(
    `${names} ${reclassified.length === 1 ? 'was' : 'were'} reclassified from Visitor to Guest to match their athlete's membership.`
  );
};

// Heads-up toast when promoting a member to Member+ cascaded their guest athletes up to full membership — the
// symmetric promotion in docs/role-and-deletion-design.html §5.6. Reads the `promotedAthletes` array the member-edit
// endpoint returns alongside its success response. No-op when nothing was promoted.
export const notifyAthletePromotions = (response) => {
  const promoted = response?.data?.promotedAthletes;
  if (!Array.isArray(promoted) || promoted.length === 0) return;
  const names =
    promoted.length === 1
      ? promoted[0]
      : `${promoted.slice(0, -1).join(', ')} and ${promoted[promoted.length - 1]}`;
  toast.info(
    `${names} ${promoted.length === 1 ? 'was' : 'were'} upgraded to full membership to match the member's new role.`
  );
};
